import React from 'react'

export default ({ serviceTxn, onClick }) => (
  <div
    className="px-4 py-3 border-b border-gray-200 last:border-b-0 bg-white hover:bg-gray-50 cursor-pointer transition-colors"
    onClick={onClick}
  >
    <div className="font-semibold text-gray-900 mb-2">
      {serviceTxn.reservation.mainPax.fullName}
    </div>
    <div className="flex items-center justify-between text-sm text-gray-600">
      <span>{serviceTxn.reservation.confirmationNumber}</span>
      <span className="text-gray-500">
        {serviceTxn.serviceInfo.inTime.fromNow()}
      </span>
    </div>
  </div>
)
